import { Injectable } from "@angular/core";
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

@Injectable({
  providedIn: "root"
})
export class BrowserInactivityService {
    constructor(private idle: Idle,private keepalive: Keepalive) { 

    }
    setIdle(idleTimeInMinute){
      this.idle.setIdle(idleTimeInMinute*60);
    }
    setTimeout(timeOutInMinute){
      this.idle.setTimeout(timeOutInMinute*60);
    }
    setInterrupts(){
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    }
    onIdleEnd(){
      return this.idle.onIdleEnd;
    }
    onItemTimeout(){
      return this.idle.onTimeout;
    }
    onIdleStart(){
      return this.idle.onIdleStart;
    }
    onTimeoutWarning(){
      return this.idle.onTimeoutWarning;
    }
    keepAlive=()=>this.keepalive.interval(15);
    onPing=()=>this.keepalive.onPing;
  
    watch=()=>this.idle.watch();
  
    stop(){
      this.idle.stop();
    }

    loadBrowserInactivity(timeOutInMinutes){
      if(timeOutInMinutes && timeOutInMinutes>0){
        this.setIdle(timeOutInMinutes/2); // how long can they be inactive before considered idle, in seconds
        this.setTimeout(timeOutInMinutes/2); // how long can they be idle before considered timed out, in seconds
        this.watch();
      }
    }
   
  }
